import en from './en';

// English remains the fallback baseline; translated keys below override it.
const ur = {
  ...en,
  "언어": "زبان",
  "로그인": "لاگ اِن",
  "로그아웃": "لاگ آؤٹ",
  "비밀번호": "پاس ورڈ",
  "서버 오류": "سرور کی خرابی",
  "로그인 실패: ": "لاگ اِن ناکام: ",
  "🔐 어드민 로그인": "🔐 ایڈمن لاگ اِن",
  "유저 관리": "یوزر مینجمنٹ",
  "테이블 관리": "ٹیبل مینجمنٹ",
  "전광판": "مارکی",
  "자산기록": "اثاثہ ریکارڈ",
  "결제관리": "ادائیگی مینجمنٹ",
  "라운지 관리": "لاؤنج مینجمنٹ",
  "공지 관리": "نوٹس مینجمنٹ",
  "광고 관리": "اشتہار مینجمنٹ",
  "검색": "تلاش",
  "검색어를 입력하세요": "تلاش کا لفظ درج کریں",
  "새로고침": "ری فریش",
  "로딩 중...": "لوڈ ہو رہا ہے...",
  "로딩중...": "لوڈ ہو رہا ہے...",
  "불러오는 중…": "لوڈ ہو رہا ہے…",
  "불러오기 실패": "لوڈ ناکام",
  "데이터 없음": "کوئی ڈیٹا نہیں",
  "데이터가 없습니다.": "کوئی ڈیٹا دستیاب نہیں۔",
  "표시할 기록이 없습니다.": "دکھانے کے لیے کوئی ریکارڈ نہیں۔",
  "생성": "بنائیں",
  "생성 중...": "بن رہا ہے...",
  "생성 중…": "بن رہا ہے…",
  "생성 실패: ": "بنانا ناکام: ",
  "생성 에러:": "بنانے کی خرابی:",
  "수정": "ترمیم",
  "저장": "محفوظ کریں",
  "저장 중...": "محفوظ ہو رہا ہے...",
  "저장 실패": "محفوظ کرنا ناکام",
  "삭제": "حذف کریں",
  "삭제 실패": "حذف ناکام",
  "삭제됨": "حذف شدہ",
  "취소": "منسوخ",
  "닫기": "بند کریں",
  "확인": "تصدیق",
  "복사": "کاپی",
  "상태": "حالت",
  "상세": "تفصیل",
  "관리": "انتظام",
  "관리 상태": "ایڈمن حالت",
  "노출": "نمایاں",
  "노출중": "نمایاں",
  "비활성": "غیر فعال",
  "활성": "فعال",
  "게시": "شائع",
  "게시 중": "شائع ہو رہا ہے",
  "게시 상태": "اشاعت کی حالت",
  "만료": "ختم",
  "만료일:": "ختم ہونے کی تاریخ:",
  "게시일:": "اشاعت کی تاریخ:",
  "예약": "شیڈول",
  "예약 없음": "کوئی شیڈول نہیں",
  "상시": "ہمیشہ",
  "미리보기": "پری ویو",
  "그룹 생성": "گروپ بنائیں",
  "그룹 이름": "گروپ نام",
  "그룹명": "گروپ نام",
  "그룹 노출(DisplaySet)": "گروپ نمائش (DisplaySet)",
  "테이블 그룹": "ٹیبل گروپ",
  "테이블 생성": "ٹیبل بنائیں",
  "테이블 목록": "ٹیبل فہرست",
  "테이블 미션": "ٹیبل مشن",
  "테이블 미션 설정": "ٹیبل مشن سیٹنگ",
  "Small Blind": "Small Blind",
  "Big Blind": "Big Blind",
  "Rake % (수수료율)": "Rake % (فیس ریٹ)",
  "라운지 포인트 %": "لاؤنج پوائنٹ %",
  "라운지 포인트 % (0~100)": "لاؤنج پوائنٹ % (0–100)",
  "라운지 포인트 지급률": "لاؤنج پوائنٹ ریٹ",
  "현재 라운지 포인트 %": "موجودہ لاؤنج پوائنٹ %",
  "startAt (시작)": "startAt (شروع)",
  "endAt (종료, 선택)": "endAt (اختتام، اختیاری)",
  "시작": "شروع",
  "종료": "اختتام",
  "시작(로컬)": "شروع (لوکل)",
  "종료(로컬)": "اختتام (لوکل)",
  "시작일": "شروع تاریخ",
  "기간": "مدت",
  "무한(30일 갱신)": "لامحدود (30 دن تجدید)",
  "24시간 반복": "ہر 24 گھنٹے دہرائیں",
  "공지 작성/관리": "نوٹس بنائیں/انتظام",
  "공지 제목": "نوٹس عنوان",
  "공지 본문": "نوٹس متن",
  "공지 수정": "نوٹس ترمیم",
  "새 공지 작성": "نیا نوٹس بنائیں",
  "광고 이미지 등록/관리": "اشتہار تصویر رجسٹر/انتظام",
  "광고 수정": "اشتہار ترمیم",
  "새 광고 등록": "نیا اشتہار رجسٹر",
  "광고 이미지": "اشتہار تصویر",
  "라운지 글": "لاؤنج پوسٹ",
  "라운지 글 목록": "لاؤنج پوسٹ فہرست",
  "라운지 아이템": "لاؤنج آئٹم",
  "라운지 업로드": "لاؤنج اپلوڈ",
  "라운지포인트": "لاؤنج پوائنٹس",
  "결제 영역": "ادائیگی علاقہ",
  "결제 옵션": "ادائیگی آپشنز",
  "결제 옵션 추가": "ادائیگی آپشن شامل کریں",
  "결제 완료": "ادائیگی مکمل",
  "결제 항목": "ادائیگی آئٹم",
  "금액": "رقم",
  "수량": "مقدار",
  "미결제": "غیر ادا شدہ",
  "자산": "اثاثہ",
  "레이크백": "Rakeback",
  "일반 자산": "عام اثاثہ",
  "라운지포인트": "لاؤنج پوائنٹس",
  "관리자 자산 표시 영역": "ایڈمن اثاثہ خلاصہ علاقہ",
  "나의 지갑 주소": "میرا والٹ پتہ",
  "보내는 지갑": "بھیجنے والا والٹ",
  "받는 지갑": "وصولی والٹ",
  "에이전트": "ایجنٹ",
  "에이전트로 생성": "ایجنٹ کے طور پر بنائیں",
  "하위 계정 생성": "ذیلی اکاؤنٹ بنائیں",
  "하위 생성": "چائلڈ بنائیں",
  "하위 {id}": "چائلڈ {id}",
  "소속 유저": "تفویض شدہ یوزرز",
  "소속유저": "تفویض شدہ یوزرز",
  "상위 에이전트:": "پیرنٹ ایجنٹ:",
  "수수료": "فیس",
  "수수료 수정": "فیس ترمیم",
  "수수료 수정 실패": "فیس ترمیم ناکام",
  "분배 비율": "تقسیم شرح",
  "분배 비율(상대 %)": "تقسیم شرح (نسبتی %)",
  "Country 필터": "ملک فلٹر",
  "Device 필터": "ڈیوائس فلٹر",
  "동아시아": "مشرقی ایشیا",
  "동남아": "جنوب مشرقی ایشیا",
  "유럽": "یورپ",
  "북미": "شمالی امریکہ",
  "남미": "جنوبی امریکہ",
  "아프리카": "افریقہ",
  "글로벌": "گلوبل",
  "제목": "عنوان",
  "본문": "متن",
  "내용(message)": "مواد (message)",
  "이미지": "تصویر",
  "이미지 URL": "تصویر URL",
  "업로드": "اپلوڈ",
  "업로드중...": "اپلوڈ ہو رہا ہے...",
  "링크 열기": "لنک کھولیں",
  "링크:": "لنک:",
  "인포카드": "انفو کارڈ",
  "하이라이트 포인트": "ہائی لائٹ پوائنٹ",
  "하이라이트 메세지": "ہائی لائٹ پیغام",
  "프리셋 수정": "پری سیٹ ترمیم",
  "배경 색상": "پس منظر رنگ",
  "배경 이미지 URL": "پس منظر تصویر URL",
  "배경 타입": "پس منظر قسم",
  "폰트스타일": "فونٹ اسٹائل",
  "굵기": "وزن",
  "색상": "رنگ",
  "표시명": "ڈسپلے نام",
  "페이지": "صفحہ",
  "페이지 크기": "صفحہ سائز",
  "다음": "اگلا",
  "이전": "پچھلا",
  "위로": "اوپر",
  "아래로": "نیچے",
  "펼치기": "کھولیں",
  "개": "آئٹمز",
  "건": "ریکارڈز",
  "명": "یوزرز",
  "⚠️ 권한이 없습니다": "⚠️ اجازت نہیں",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "آپ کو اس صفحہ تک رسائی کی اجازت نہیں ہے۔",
};

export default ur;
